// @flow strict
import * as React from 'react';
import type { IAPReason } from './IAPReason';
import type { SubmissionForm } from './useReportForm';

const useFormToSubmission = (reason: ?IAPReason, form: SubmissionForm) =>
  React.useMemo(() => {
    if (!reason) {
      return null;
    }
    return {
      reason,
      comment: form.comment || '',
    };
  }, [reason, form]);

export default useFormToSubmission;
